import React, { useEffect, useRef, useState } from "react";
import { RoutePath } from "./../../routes";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { CartOff } from "./components/CartOff";
import axios from "axios";
import { toast } from "react-toastify";

const megaMenuStyles = `
  .search-result-item:hover { background: #f4fbf5 !important; }
  .mega-wrap { position: relative; }
  .mega-menu {
    position: absolute;
    top: calc(100% + -5);
    left: 50%;
    transform: translateX(-50%) translateY(-6px);
    width: 700px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    box-shadow: 0 16px 48px rgba(0,0,0,0.10), 0 4px 12px rgba(0,0,0,0.06);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s;
    z-index: 9999;
  }
  .mega-wrap:hover .mega-menu {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    transform: translateX(-50%) translateY(0);
  }
  .mega-inner { display: grid; grid-template-columns: 200px 1fr; }
  .mega-cat-panel { border-right: 1px solid #e5e7eb; padding: 10px 0; }
  .mega-cat-item {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 20px; cursor: pointer; transition: background 0.12s;
    border-left: 3px solid transparent;
  }
  .mega-cat-item:hover, .mega-cat-item.active { background: #f5f5f5; border-left-color: #66A96B; }
  .mega-cat-item:hover .mega-cat-name, .mega-cat-item.active .mega-cat-name { color: #66A96B; }
  .mega-cat-name { color: #222; font-weight: 600; transition: color 0.12s; }
  .mega-prod-panel { padding: 16px 20px; overflow-y: auto; max-height: 420px; }
  .mega-sub-section { display: none; }
  .mega-sub-section.active { display: block; }
  .mega-sub-label {
    display: block; padding: 8px 0 4px; color: #66A96B;
    text-transform: uppercase; letter-spacing: 1px; font-weight: 700;
    text-decoration: none; margin-bottom: 6px; padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }
  .mega-sub-label:not(:first-child) { margin-top: 14px; }
  .mega-prod-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px; }
  .mega-prod-card {
    display: flex; align-items: center; gap: 10px; padding: 8px 10px;
    border-radius: 6px; border: 1px solid transparent; text-decoration: none;
    transition: background 0.12s, border-color 0.12s;
  }
  .mega-prod-card:hover { background: #f5f5f5; border-color: #e0e0e0; }
  .mega-prod-thumb {
    width: 38px; height: 38px; border-radius: 4px; border: 1px solid #eee;
    object-fit: cover; flex-shrink: 0; background: #f9f9f9;
  }
  .mega-prod-name { font-size: 13px; font-weight: 500; color: #222; line-height: 1.35; }
  .mega-prod-price { font-size: 12px; color: #66A96B; font-weight: 600; margin-top: 2px; }
  .mega-view-all { margin-top: 12px; padding-top: 10px; border-top: 1px solid #f0f0f0; text-align: right; }
  .mega-view-all a { font-size: 13px; color: #66A96B; font-weight: 600; text-decoration: none; }
  .mega-view-all a:hover { text-decoration: underline; }
  .mega-trigger-chevron { transition: transform 0.2s; display: inline-block; }
  .mega-wrap:hover .mega-trigger-chevron { transform: rotate(180deg); }

  /* WhatsApp Floating Button */
  .whatsapp-float {
    position: fixed;
    bottom: 24px;
    right: 24px;
    background-color: #25D366;
    color: #fff;
    border-radius: 50px;
    text-align: center;
    box-shadow: 0 4px 15 rgba(0, 0, 0, 0.2);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    text-decoration: none;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .whatsapp-float:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    color: #fff;
  }
  .whatsapp-tooltip {
    position: absolute;
    right: 70px;
    background: #333;
    color: #fff;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0.2s;
    pointer-events: none;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  .whatsapp-float:hover .whatsapp-tooltip {
    opacity: 1;
    visibility: visible;
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  /* Coupon Ticker Styles */
  .coupon-ticker-wrap {
    width: 100%;
    background-color: #222222;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    padding: 8px 0;
    border-bottom: 2px solid #66A96B;
    box-shadow: 0 4px 10px rgba(0,0,0,0.05);
    display: flex;
    align-items: center;
    user-select: none;
  }
  .coupon-ticker-content {
    display: flex;
    width: max-content;
    animation: couponMarquee 25s linear infinite;
  }
  .coupon-ticker-set {
    display: flex;
    align-items: center;
  }
  .coupon-ticker-item {
    padding: 0 50px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
  }
  @keyframes couponMarquee {
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(-50%, 0, 0); }
  }
  .coupon-ticker-wrap:hover .coupon-ticker-content {
    animation-play-state: paused;
    cursor: pointer;
  }

  /* Responsive Mega Menu Styles */
  @media (max-width: 991px) {
    .mega-menu {
      position: static !important;
      transform: none !important;
      width: 100% !important;
      box-shadow: none !important;
      border: none !important;
      border-radius: 0 !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: all !important;
      max-height: none !important;
      display: none;
    }
    .mega-wrap:hover .mega-menu {
      display: block !important;
    }
    .mega-inner {
      display: flex !important;
      flex-direction: column !important;
    }
    .mega-cat-panel {
      border-right: none !important;
      border-bottom: 1px solid #e5e7eb !important;
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 6px !important;
      padding: 10px 0 !important;
    }
    .mega-cat-item {
      padding: 6px 12px !important;
      border: 1px solid #e5e7eb !important;
      border-radius: 20px !important;
      border-left: none !important;
      justify-content: center !important;
    }
    .mega-cat-item.active {
      border-color: #66A96B !important;
      background: #f5f5f5 !important;
    }
    .mega-cat-item i {
      display: none !important;
    }
    .mega-prod-panel {
      max-height: 320px !important;
      padding: 12px 0 !important;
    }
    .mega-prod-grid {
      grid-template-columns: 1fr !important;
      gap: 6px !important;
    }
    .mega-sub-label {
      font-size: 13px !important;
      margin-top: 10px !important;
    }

    /* Mobile Responsiveness for Header Icons & Toggler */
    .navbar-brand {
      max-width: 150px !important;
      flex-shrink: 1 !important;
    }
    .navbar-brand img {
      max-height: 42px !important;
      width: auto !important;
      object-fit: contain !important;
    }
    .nav-icons-container {
      display: flex !important;
      align-items: center !important;
      gap: 6px !important;
      flex-shrink: 0 !important;
    }
    .nav-icons-container .icon, .nav-icons-container .nav-icon-btn {
      margin-right: 0 !important;
    }
    .navbar-toggler {
      padding: 6px !important;
      flex-shrink: 0 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    .nav-links {
      align-items: flex-start !important;
      padding-top: 10px !important;
    }
    .nav-item {
      width: 100% !important;
      border-bottom: 1px solid #f0f0f0;
    }
    .nav-link {
      padding: 10px 0 !important;
      font-size: 14px !important;
    }
  }

  /* Premium Modern Navbar Styling */
  .main-header {
    background: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    border-bottom: 1px solid #eaeaea;
  }
  .nav-icon-btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #f4f6f4;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: 16px;
    transition: all 0.2s ease;
    text-decoration: none !important;
  }
  .nav-icon-btn:hover {
    background: #eaf4eb;
    color: #66A96B;
    transform: translateY(-1px);
  }
  .cart-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    background: #66A96B;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 10px;
    line-height: 1;
    box-shadow: 0 2px 4px rgba(102,169,107,0.3);
  }
  .search-pill-box {
    border: 1.5px solid #d4e6d5;
    border-radius: 25px;
    overflow: hidden;
    background-color: #f9fbf9;
    transition: all 0.2s ease;
  }
  .search-pill-box:focus-within {
    border-color: #66A96B;
    box-shadow: 0 0 0 3px rgba(102, 169, 107, 0.15);
    background-color: #ffffff;
  }
`;

function getImageUrl(image) {
  if (!image) return "";
  if (image.startsWith("http://") || image.startsWith("https://")) return image;
  return `${process.env.REACT_APP_ASSET_URL}/${image}`;
}

function Approot({
  fetchCategory,
  categories,
  isLoggedIn,
  cart,
  changeAddToFalse,
  isAdded,
  updateCart,
  fetchCart,
  deleteCart,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const offcanvasRef = useRef(null);
  const [totals, setTotals] = useState({ totalQuantity: 0, totalPrice: 0 });
  const [activeCatId, setActiveCatId] = useState(null);

  // Live Search Bar State
  const [searchQuery, setSearchQuery] = useState("");
  const [allProductsList, setAllProductsList] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchRef = useRef(null);
  const searchRefMobile = useRef(null);

  useEffect(() => {
    const fetchActiveProducts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/active`);
        setAllProductsList(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching products for live search:", err);
      }
    };
    fetchActiveProducts();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const outsideDesktop = searchRef.current && !searchRef.current.contains(event.target);
      const outsideMobile = searchRefMobile.current && !searchRefMobile.current.contains(event.target);
      if (outsideDesktop && outsideMobile) {
        setIsSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const searchResults = searchQuery.trim().length > 0
    ? allProductsList.filter((prod) =>
        prod.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        prod.tags?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  // Review & Rating Popup States
  const [currentPendingReview, setCurrentPendingReview] = useState(null);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [submittingReview, setSubmittingReview] = useState(false);

  // Common Coupons Ticker state
  const [commonCoupons, setCommonCoupons] = useState([]);

  const fetchPendingReviews = async () => {
    const token = sessionStorage.getItem("userToken") || localStorage.getItem("userToken");
    if (!token) return;
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/order/pending-reviews`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = response.data.data || [];
      if (data.length > 0) {
        setCurrentPendingReview((prev) => {
          if (!prev) return data[0];
          const exists = data.some((item) => Number(item.product.id) === Number(prev.product.id) && Number(item.orderId) === Number(prev.orderId));
          return exists ? prev : data[0];
        });
      } else {
        setCurrentPendingReview(null);
      }
    } catch (err) {
      console.error("Error fetching pending reviews:", err);
    }
  };

  // Poll for delivered orders with pending reviews every 5 seconds
  useEffect(() => {
    const token = sessionStorage.getItem("userToken") || localStorage.getItem("userToken");
    if (!token) return;

    fetchPendingReviews(); // initial fetch

    const interval = setInterval(() => {
      fetchPendingReviews();
    }, 5000);

    return () => clearInterval(interval);
  }, [isLoggedIn]);

  const handleReviewSubmit = async () => {
    if (!rating || rating < 1 || rating > 5) {
      toast.error("Please select a rating between 1 and 5.");
      return;
    }
    setSubmittingReview(true);
    try {
      const token = sessionStorage.getItem("userToken") || localStorage.getItem("userToken");
      await axios.post(
        `${process.env.REACT_APP_API_URL}/review`,
        {
          rating,
          comment,
          ProductId: currentPendingReview.product.id,
          OrderId: currentPendingReview.orderId
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      toast.success("Review submitted successfully! Thank you.");
      setComment("");
      setRating(5);
      setCurrentPendingReview(null);
      await fetchPendingReviews();
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.message || "Failed to submit review.";
      toast.error(msg);
    } finally {
      setSubmittingReview(false);
    }
  };

  useEffect(() => {
    fetchCategory();
    if (cart.length === 0) fetchCart();

    // Track affiliate & influencer referral parameter in URL
    const params = new URLSearchParams(window.location.search);
    const refId =
      params.get("ref") ||
      params.get("aff") ||
      params.get("affiliate") ||
      params.get("affiliateId") ||
      params.get("inf") ||
      params.get("influencer") ||
      params.get("coupon") ||
      params.get("code");
    if (refId) {
      if (isNaN(refId)) {
        localStorage.setItem("autoCouponCode", refId);
        console.log("Saved auto coupon code:", refId);
      } else {
        localStorage.setItem("affiliateRefId", refId);
        console.log("Saved affiliate reference ID:", refId);
      }
    }

    const fetchCommonCoupons = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/coupon/public-list`);
        const data = response.data?.data || [];
        const activeCommon = data.filter(c => c.status === 1 && !c.AffiliateId);
        setCommonCoupons(activeCommon);
      } catch (err) {
        console.error("Error fetching coupons:", err);
      }
    };
    fetchCommonCoupons();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (Array.isArray(categories) && categories.length > 0) {
      setActiveCatId((prev) => prev ?? categories[0].id);
    }
  }, [categories]);

  useEffect(() => {
    if (isAdded) {
      fetchCart();
      const el = offcanvasRef.current;
      if (el && !el.classList.contains("show")) {
        new window.bootstrap.Offcanvas(el).show();
      }
      const handleClose = () => changeAddToFalse();
      el?.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => el?.removeEventListener("hidden.bs.offcanvas", handleClose);
    }
  }, [isAdded]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (cart && cart.length > 0) {
      const result = cart.reduce(
        (acc, item) => {
          acc.totalQuantity += parseInt(item.quantity) || 0;
          acc.totalPrice +=
            (parseInt(item.quantity) || 0) *
            (parseFloat(item.Product?.currentPrice) || 0);
          return acc;
        },
        { totalQuantity: 0, totalPrice: 0 },
      );
      setTotals(result);
    } else {
      setTotals({ totalQuantity: 0, totalPrice: 0 });
    }
  }, [cart]);

  // Close mobile navigation menu on route change
  useEffect(() => {
    const collapseEl = document.getElementById("navbarNav");
    if (collapseEl && collapseEl.classList.contains("show")) {
      if (window.bootstrap?.Collapse) {
        const bsCollapse = window.bootstrap.Collapse.getInstance(collapseEl) || new window.bootstrap.Collapse(collapseEl);
        bsCollapse.hide();
      } else {
        // Fallback: manually toggle classes and attributes
        collapseEl.classList.remove("show");
        const toggler = document.querySelector(".navbar-toggler");
        if (toggler) {
          toggler.setAttribute("aria-expanded", "false");
          toggler.classList.add("collapsed");
        }
      }
    }
  }, [location.pathname]);

  // ── Your API returns { message: 'Success', data: [...] }
  // The Redux action must store response.data — check categoryAction.js
  // If Redux stores the full response object, unwrap it here:
  const catList = Array.isArray(categories)
    ? categories
    : Array.isArray(categories?.data)
      ? categories.data
      : [];

  return (
    <>
      <style>{megaMenuStyles}</style>

      <CartOff
        offcanvasRef={offcanvasRef}
        cart={cart}
        updateCart={updateCart}
        totals={totals}
        deleteCart={deleteCart}
      />

      <header
        className="main-header"
        style={{
          position: "relative",
          zIndex: 1000,
        }}
      >
        <nav className="navbar navbar-expand-lg navbar-light py-2 bg-transparent">
          <div className="container">
            {/* Top Header Row */}
            <div className="d-flex align-items-center justify-content-between w-100 position-relative">

              {/* Logo */}
              <Link className="navbar-brand m-0" to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/logo.jpg`}
                  alt="Bhabhuti Herbals"
                  style={{ maxHeight: "50px", width: "auto", objectFit: "contain" }}
                />
              </Link>

              {/* Desktop Live Search Bar (Hidden on Mobile < 992px) */}
              <div
                ref={searchRef}
                className="position-relative d-none d-lg-block mx-4 flex-grow-1"
                style={{ maxWidth: "360px" }}
              >
                <div className="input-group search-pill-box">
                  <input
                    type="text"
                    className="form-control border-0 bg-transparent px-3 py-2"
                    placeholder="Search Ayurveda, Oils, Soaps..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setIsSearchOpen(true);
                    }}
                    onFocus={() => setIsSearchOpen(true)}
                    style={{ fontSize: "14px", outline: "none", boxShadow: "none" }}
                  />
                  <button
                    className="btn border-0 bg-transparent pe-3"
                    type="button"
                    style={{ color: "#66A96B" }}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>

                {/* Live Dropdown Results */}
                {isSearchOpen && searchQuery.trim().length > 0 && (
                  <div
                    className="position-absolute start-0 w-100 bg-white shadow-lg rounded mt-2 border"
                    style={{ zIndex: 1100, maxHeight: "350px", overflowY: "auto", borderTop: "3px solid #66A96B" }}
                  >
                    {searchResults.length > 0 ? (
                      searchResults.map((prod) => (
                        <div
                          key={prod.id}
                          className="d-flex align-items-center p-2 border-bottom search-result-item"
                          style={{ cursor: "pointer", transition: "background 0.15s" }}
                          onClick={() => {
                            navigate(`/product/${prod.slug}`);
                            setSearchQuery("");
                            setIsSearchOpen(false);
                          }}
                        >
                          <img
                            src={getImageUrl(prod.image)}
                            alt={prod.name}
                            style={{
                              width: "42px",
                              height: "42px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              marginRight: "12px",
                              border: "1px solid #eee"
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                          <div className="flex-grow-1" style={{ overflow: "hidden" }}>
                            <div
                              className="fw-bold text-dark text-truncate"
                              style={{ fontSize: "13px", lineHeight: "1.3" }}
                            >
                              {prod.name}
                            </div>
                            <div
                              className="fw-bold"
                              style={{ fontSize: "12px", color: "#66A96B", marginTop: "2px" }}
                            >
                              ₹{prod.currentPrice}
                            </div>
                          </div>
                          <i className="fa-solid fa-chevron-right text-muted ms-2" style={{ fontSize: "11px" }}></i>
                        </div>
                      ))
                    ) : (
                      <div className="p-3 text-center text-muted" style={{ fontSize: "13px" }}>
                        No products matching "{searchQuery}"
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Right Side Icons & Mobile Toggler Container */}
              <div className="nav-icons-container ms-auto ms-lg-0 d-flex align-items-center">
                {isLoggedIn && (
                  <div className="dropdown me-2">
                    <div
                      className="nav-icon-btn dropdown-toggle"
                      style={{ cursor: "pointer" }}
                      data-bs-toggle="dropdown"
                      title="Account"
                    >
                      <i className="fa fa-user"></i>
                    </div>
                    <ul className="dropdown-menu dropdown-menu-end shadow border-0 rounded-3 mt-2">
                      <li>
                        <Link className="dropdown-item py-2 fw-semibold" to="/profile">
                          <i className="fa fa-user-circle me-2 text-success"></i> Profile
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item py-2 fw-semibold" to="/orders">
                          <i className="fa fa-box me-2 text-success"></i> Orders
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider my-1" />
                      </li>
                      <li>
                        <Link
                          className="dropdown-item py-2 fw-semibold text-danger"
                          onClick={() => {
                            sessionStorage.removeItem("loggedUser");
                            sessionStorage.removeItem("userToken");
                            window.location.href = "/login";
                          }}
                        >
                          <i className="fa fa-sign-out-alt me-2"></i> Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}

                {/* Wishlist Icon */}
                <div
                  className="nav-icon-btn me-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/wishlist")}
                  title="Wishlist"
                >
                  <i className="bi bi-heart"></i>
                </div>

                {/* Cart Icon */}
                <div
                  className="nav-icon-btn position-relative me-2"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                  title="Cart"
                >
                  <i className="bi bi-bag"></i>
                  {totals.totalQuantity > 0 && (
                    <span className="cart-badge">{totals.totalQuantity}</span>
                  )}
                </div>

                {/* Mobile Menu Toggler */}
                <button
                  className="navbar-toggler border-0 p-2 rounded-circle ms-1"
                  style={{ background: "#f4f6f4" }}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>

            </div>

            {/* Mobile Search Bar Row (Visible ONLY on Mobile < 992px) */}
            <div className="d-lg-none w-100 mt-2">
              <div
                ref={searchRefMobile}
                className="position-relative w-100"
              >
                <div className="input-group search-pill-box">
                  <input
                    type="text"
                    className="form-control border-0 bg-transparent px-3 py-2"
                    placeholder="Search Ayurveda, Oils, Soaps..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setIsSearchOpen(true);
                    }}
                    onFocus={() => setIsSearchOpen(true)}
                    style={{ fontSize: "14px", outline: "none", boxShadow: "none" }}
                  />
                  <button
                    className="btn border-0 bg-transparent pe-3"
                    type="button"
                    style={{ color: "#66A96B" }}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>

                {/* Live Dropdown Results */}
                {isSearchOpen && searchQuery.trim().length > 0 && (
                  <div
                    className="position-absolute start-0 w-100 bg-white shadow-lg rounded mt-2 border"
                    style={{ zIndex: 1100, maxHeight: "350px", overflowY: "auto", borderTop: "3px solid #66A96B" }}
                  >
                    {searchResults.length > 0 ? (
                      searchResults.map((prod) => (
                        <div
                          key={prod.id}
                          className="d-flex align-items-center p-2 border-bottom search-result-item"
                          style={{ cursor: "pointer", transition: "background 0.15s" }}
                          onClick={() => {
                            navigate(`/product/${prod.slug}`);
                            setSearchQuery("");
                            setIsSearchOpen(false);
                          }}
                        >
                          <img
                            src={getImageUrl(prod.image)}
                            alt={prod.name}
                            style={{
                              width: "42px",
                              height: "42px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              marginRight: "12px",
                              border: "1px solid #eee"
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                          <div className="flex-grow-1" style={{ overflow: "hidden" }}>
                            <div
                              className="fw-bold text-dark text-truncate"
                              style={{ fontSize: "13px", lineHeight: "1.3" }}
                            >
                              {prod.name}
                            </div>
                            <div
                              className="fw-bold"
                              style={{ fontSize: "12px", color: "#66A96B", marginTop: "2px" }}
                            >
                              ₹{prod.currentPrice}
                            </div>
                          </div>
                          <i className="fa-solid fa-chevron-right text-muted ms-2" style={{ fontSize: "11px" }}></i>
                        </div>
                      ))
                    ) : (
                      <div className="p-3 text-center text-muted" style={{ fontSize: "13px" }}>
                        No products matching "{searchQuery}"
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Collapsible Mobile Navigation Menu */}
            <div className="collapse navbar-collapse w-100" id="navbarNav">
              <ul
                className="navbar-nav ms-auto nav-links"
                style={{ alignItems: "center" }}
              >
                <li className="nav-item">
                  <Link className={`nav-link ${location.pathname === "/" ? "active" : ""}`} to="/">
                    Home
                  </Link>
                </li>

                {/* ── Products mega-menu ── */}
                <li className="nav-item mega-wrap">
                  <Link
                    to="/products"
                    className={`nav-link ${location.pathname === "/products" || location.pathname.startsWith("/product") || location.pathname.startsWith("/category") ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                  >
                    Products{" "}
                    <i
                      className="fa-solid fa-chevron-down mega-trigger-chevron"
                      style={{ fontSize: 11 }}
                    ></i>
                  </Link>

                  {catList.length > 0 && (
                    <div className="mega-menu">
                      <div className="mega-inner">
                        {/* Left: category names */}
                        <div className="mega-cat-panel">
                          {catList.map((cat) => (
                            <div
                              key={cat.id}
                              className={`mega-cat-item ${activeCatId === cat.id ? "active" : ""}`}
                              onMouseEnter={() => setActiveCatId(cat.id)}
                            >
                              <span className="mega-cat-name">{cat.name}</span>
                              <i
                                className="fa-solid fa-chevron-right"
                                style={{ fontSize: 11, color: "#aaa" }}
                              ></i>
                            </div>
                          ))}
                        </div>

                        {/* Right: products panel */}
                        <div className="mega-prod-panel">
                          {catList.map((cat) => {
                            const subcategories = cat.subcategories || [];
                            const directProducts = cat.products || [];

                            return (
                              <div
                                key={cat.id}
                                className={`mega-sub-section ${activeCatId === cat.id ? "active" : ""}`}
                              >
                                {subcategories.length > 0 ? (
                                  subcategories.map((sub) => {
                                    const subProducts = sub.products || [];
                                    return (
                                      <div key={sub.id}>
                                        <Link
                                          to={`/category/${sub.slug}`}
                                          className="mega-sub-label"
                                        >
                                          {sub.name}
                                        </Link>
                                        {subProducts.length > 0 ? (
                                          <div className="mega-prod-grid">
                                            {subProducts.map((prod) => (
                                              <Link
                                                key={prod.id}
                                                to={`/product/${prod.slug}`}
                                                className="mega-prod-card"
                                              >
                                                <img
                                                  src={getImageUrl(prod.image)}
                                                  alt={prod.name}
                                                  className="mega-prod-thumb"
                                                  onError={(e) => {
                                                    e.target.style.display =
                                                      "none";
                                                  }}
                                                />
                                                <div>
                                                  <div className="mega-prod-name">
                                                    {prod.name}
                                                  </div>
                                                  <div className="mega-prod-price">
                                                    ₹{prod.currentPrice}
                                                  </div>
                                                </div>
                                              </Link>
                                            ))}
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              padding: "6px 0 8px",
                                              fontSize: 12,
                                              color: "#aaa",
                                            }}
                                          >
                                            No products
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })
                                ) : directProducts.length > 0 ? (
                                  <div className="mega-prod-grid">
                                    {directProducts.map((prod) => (
                                      <Link
                                        key={prod.id}
                                        to={`/product/${prod.slug}`}
                                        className="mega-prod-card"
                                      >
                                        <img
                                          src={getImageUrl(prod.image)}
                                          alt={prod.name}
                                          className="mega-prod-thumb"
                                          onError={(e) => {
                                            e.target.style.display = "none";
                                          }}
                                        />
                                        <div>
                                          <div className="mega-prod-name">
                                            {prod.name}
                                          </div>
                                          <div className="mega-prod-price">
                                            ₹{prod.currentPrice}
                                          </div>
                                        </div>
                                      </Link>
                                    ))}
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      padding: "6px 0 8px",
                                      fontSize: 12,
                                      color: "#aaa",
                                    }}
                                  >
                                    No products in this category
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </li>

                <li className="nav-item">
                  <Link className={`nav-link ${location.pathname === "/page/about-us" ? "active" : ""}`} to="/page/about-us">
                    About Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link ${location.pathname === "/contact-us" ? "active" : ""}`} to="/contact-us">
                    Contact
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link ${location.pathname === "/gallery" ? "active" : ""}`} to="/gallery">
                    Gallery
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${["/affiliate-login", "/become-an-affiliate", "/affiliate-dashboard"].includes(location.pathname) ? "active" : ""}`}
                    to="/affiliate-login"
                  >
                    Affiliate Login
                  </Link>
                </li>
                {!isLoggedIn && (
                  <li className="nav-item">
                    <Link
                      className={`nav-link ${["/login", "/register", "/forget-password"].includes(location.pathname) ? "active" : ""}`}
                      to="/login"
                    >
                      Customer Login
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </header>

      {/* Scrolling Coupon Ticker */}
      {commonCoupons.length > 0 && (
        <div className="coupon-ticker-wrap">
          <div className="coupon-ticker-content">
            {/* First Set */}
            <div className="coupon-ticker-set">
              {commonCoupons.map((coupon) => {
                const offerText = coupon.type === 1
                  ? `${coupon.value}% OFF (Up to ₹${coupon.upto})`
                  : `Flat ₹${coupon.value} OFF`;
                return (
                  <span key={coupon.id} className="coupon-ticker-item">
                    🎉 Special Offer: Use Code <strong style={{ color: '#FFD700', textTransform: 'uppercase' }}>{coupon.code}</strong> to get {offerText}! (Min Purchase: ₹500)
                  </span>
                );
              })}
            </div>
            {/* Second Set (Duplicate for seamless loop) */}
            <div className="coupon-ticker-set">
              {commonCoupons.map((coupon) => {
                const offerText = coupon.type === 1
                  ? `${coupon.value}% OFF (Up to ₹${coupon.upto})`
                  : `Flat ₹${coupon.value} OFF`;
                return (
                  <span key={`dup-${coupon.id}`} className="coupon-ticker-item">
                    🎉 Special Offer: Use Code <strong style={{ color: '#FFD700', textTransform: 'uppercase' }}>{coupon.code}</strong> to get {offerText}! (Min Purchase: ₹500)
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      )}

      <RoutePath />

      <div
        className="full-row bg-dark py-4"
        style={{ minHeight: "125px", alignItems: "center", display: "flex" }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6 text-center text-md-start">
              <h4 className="text-white mb-3 text-uppercase">
                Sign up to newsletter
              </h4>
            </div>
            <div className="col-lg-7 col-md-6">
              <form
                className="subscribe-form d-flex align-items-center"
                method="POST"
              >
                <input
                  className="form-control rounded-pill me-2"
                  type="text"
                  placeholder="Enter your email"
                  name="email"
                />
                <button
                  type="submit"
                  className="btn btn-secondary rounded-pill text-white"
                >
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="footer container py-4">
        <div className="row gy-4">
          <div className="col-lg-3 col-md-6">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/logo.jpg`}
              alt="Bhabhuti Herbal Logo"
            />
            <p>
              <strong>We Support 24/7!</strong>
            </p>
            <p>+91 8078609131</p>
            <p>
              <strong>Address:</strong>
            </p>
            <p>1/1 Housing Board Colony, Hanumangarh Junction - 335512</p>
            <p>
              <strong>Email:</strong>
            </p>
            <p>info@bhabhutitherbal.com</p>
            <div className="social-icons">
              <Link to="#">
                <i className="fa-brands fa-facebook-f"></i>
              </Link>
              <Link to="#">
                <i className="fa-brands fa-twitter"></i>
              </Link>
              <Link to="#">
                <i className="fa-brands fa-linkedin"></i>
              </Link>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h3>PRODUCT CATEGORY</h3>
            {catList.map((cat) => (
              <p key={cat.id}>
                <Link to={`/category/${cat.slug}`}>{cat.name}</Link>
              </p>
            ))}
          </div>
          <div className="col-lg-3 col-md-6">
            <h3>CUSTOMER CARE</h3>
            <p>
              <Link to="/">Home</Link>
            </p>
            <p>
              <Link to="/page/about-us">About Us</Link>
            </p>
            <p>
              <Link to="/page/privacy-policy">Privacy Policy</Link>
            </p>
            <p>
              <Link to="/page/terms-condition">Terms & Conditions</Link>
            </p>
            <p>
              <Link to="/page/return-refund-policy">
                Return & Refund Policy
              </Link>
            </p>
            <p>
              <Link to="/page/shipping-delivery-policy">
                Shipping & Delivery Policy
              </Link>
            </p>
            <p>
              <Link to="/contact-us">Contact Us</Link>
            </p>
            <p>
              <Link to="/faq">FAQs & Help</Link>
            </p>
          </div>
          <div className="col-lg-3 col-md-6">
            <h3>BLOG</h3>
            <p>
              <strong>The Rise of Herbal and Ayurvedic Products: A ..</strong>
            </p>
            <p>Sep 26 - 2024</p>
          </div>
        </div>
      </div>

      {/* WhatsApp Floating Support Button */}
      <a
        href="https://wa.me/918078609131?text=Hello%20Bhabhuti%20Herbal,%20I%20have%20a%20query%20about%20your%20products."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        id="whatsapp-support-btn"
      >
        <i className="fa-brands fa-whatsapp" style={{ fontSize: '32px' }}></i>
        <div className="whatsapp-tooltip">Chat with Support</div>
      </a>

      {/* Global pending review popup */}
      {currentPendingReview && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.65)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10000,
          animation: 'fadeIn 0.25s ease-out'
        }}>
          <div style={{
            backgroundColor: '#ffffff',
            padding: '30px',
            borderRadius: '16px',
            width: '90%',
            maxWidth: '460px',
            boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
            textAlign: 'left',
            position: 'relative',
            fontFamily: '"Outfit", sans-serif',
            animation: 'slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
          }}>
            <button
              onClick={() => {
                setCurrentPendingReview(null);
              }}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                border: 'none',
                background: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#aaa',
                transition: 'color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.color = '#333'}
              onMouseLeave={(e) => e.target.style.color = '#aaa'}
            >
              ✕
            </button>
            <h4 style={{ fontWeight: '700', color: '#111', marginBottom: '8px', fontSize: '20px' }}>
              How was your experience?
            </h4>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
              We noticed your order <strong>#BH{currentPendingReview.orderId}</strong> was delivered. Please share your valuable feedback!
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '12px', background: '#f9f9f9', borderRadius: '12px', marginBottom: '20px', border: '1px solid #eee' }}>
              <img
                src={getImageUrl(currentPendingReview.product.image)}
                alt={currentPendingReview.product.name}
                style={{
                  width: '64px',
                  height: '64px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  border: '1px solid #ddd',
                  background: '#fff'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#333', lineHeight: '1.4' }}>
                {currentPendingReview.product.name}
              </span>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '13px', fontWeight: '600', display: 'block', marginBottom: '6px', color: '#444' }}>Rating</label>
              <div style={{ display: 'flex', gap: '10px', fontSize: '32px', cursor: 'pointer', userSelect: 'none' }}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    onClick={() => setRating(star)}
                    style={{ color: star <= rating ? '#FFD700' : '#e0e0e0', transition: 'color 0.15s' }}
                  >
                    ★
                  </span>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ fontSize: '13px', fontWeight: '600', display: 'block', marginBottom: '6px', color: '#444' }}>Comment</label>
              <textarea
                rows="4"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Write your review here... How was the quality? Did it help?"
                className="form-control"
                style={{ resize: 'none', fontSize: '14px', borderRadius: '8px', borderColor: '#ddd', padding: '10px' }}
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <button
                className="btn btn-light"
                onClick={() => {
                  setCurrentPendingReview(null);
                }}
                disabled={submittingReview}
                style={{ fontSize: '13px', fontWeight: '600', borderRadius: '8px', padding: '8px 16px', border: '1px solid #ddd' }}
              >
                Skip for now
              </button>
              <button
                className="btn btn-success"
                onClick={handleReviewSubmit}
                disabled={submittingReview}
                style={{ fontSize: '13px', fontWeight: '600', borderRadius: '8px', padding: '8px 18px', backgroundColor: '#66A96B', borderColor: '#66A96B', color: 'white' }}
              >
                {submittingReview ? 'Submitting...' : 'Submit Review'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Approot;
